module.exports = __webpack_public_path__ + "static/media/fast-forward.cda8223a.svg";